export default {
  heading: {
    subtitle: "Recherche de fuite à Toulouse",
    icons: [
      {
        src: "/img/icons/approve-invoic-bicolor-light.png",
        alt: "Icone devis",
      },
      {
        src: "/img/icons/calendar-bicolor-light.png",
        alt: "Icone calendrier",
      },
      {
        src: "/img/icons/piggy-bank-bicolor-light.png",
        alt: "Icone tarifs",
      },
    ],
    items: [
      " Recherche de fuite non-destructrice",
      " Un rendez-vous dans la semaine",
      " Déplacement inclus",
    ],
  },
  section1: {
    title:
      "Vous constatez une hausse de votre consommation d'eau ou un dégât des eaux ?",
    text:
      "Vous constatez une hausse soudaine de votre consommation d'eau ? Vous apercevez des traces d'humidité d'eau chez vous ? <br/> Ces signes sont souvent synonymes de fuite d'eau : alimentation, raccord défaillant, ... Une fuite doit être traîtée au plus vite afin de limiter les dégâts.<br/> Cette intervention est souvent prise en charge par votre assurance. Pensez à vous renseigner.",
    ctaText: "Pour planifier une recherche de fuite, appelez nous au :",
  },
  section2: {
    steps1: [
      "Examen visuel des traces d'humidités éventuelles",
      "Vérification de la consommation d'eau via le compteur d'arrivée",
      "Inspection des différents raccords des canalisations d'alimentation et évacuation",
      "Test d'alimentation en mettant le réseau en pression via une pompe à épreuve",
      "Passage d'une caméra dans les parties les plus difficiles d'accès",
    ],
    text1:
      "Rapprochez-vous de votre assurance pour vérifier que la recherche de fuite est prise en charge.",
    text2:
      "Selon la complexité de votre installation, la recherche de fuite peut durer entre 1h et 4h.",

    text3:
      "La recherche de fuite dépend de la complexité et de la taille de votre installation.",
    steps3: [
      "Une recherche de fuite est très souvent prise en charge par votre assurance.",
      "Nous privilégions une recherche non-destructrice",
      "Dans certains cas, une recherche dite destructrice peut être nécessaire (uniquement avec votre accord)",
    ],
    ctaText: "Prenez RDV dès aujourd'hui.",
    ctaTextMobile:
      'Appelez-nous et planifiez <br />votre recherche de fuite dans <span class="no-wrap"> la semaine !</span>',
  },
  aside: {
    img: {
      src: "/img/pages/page-content_team.jpg",
      alt: "Recherche de fuite",
    },
    ctaText: "Une fuite ? Appelez-nous :",
    quoteRequest: {
      recipient: "contact+devisRechercheFuite",
      body:
        "Bonjour,%0D%0A %0D%0A J'aimerais réaliser une recherche de fuite : %0D%0A - Délai : %0D%0A - Code postal : %0D%0A - Ville : %0D%0A - Nom : %0D%0A - Numéro de téléphone (optionnel) : %0D%0A %0D%0A Bien à vous",
    },
  },
};
